{
  "title": "Comptes de paiement des frais",
  "subTitle": "Pour chaque compte, vous pouvez sélectionner un compte non enregistré différent sur lequel vous souhaitez prélever des frais.",
  "noAccountsInHousehold": "Il n'y a pas de compte dans ce ménage. Créez ou associez d'abord un compte.",
  "registeredAccounts": "Comptes enregistrés",
  "set": "Définir les comptes de paiement",
  "feePaymentAccountsUpdated": "Les comptes de paiement des taxes ont été mis à jour"
}
